import { ComponentType, ReactElement, Suspense } from 'react';
import { isMobile } from 'utils/is-mobile';

type Props = {
  mobile: ComponentType<any>;
  desktop: ComponentType<any>;
  innerProps?: object;
  fallback?: ReactElement;
  conditions?: {
    mobile?: boolean;
    desktop?: boolean;
  };
  forceViewport?: 'mobile' | 'desktop';
};

const defaultConditions = {
  mobile: true,
  desktop: true
};

export const Viewport = function (props: Props): ReactElement {
  const MobileView = props.mobile;
  const DesktopView = props.desktop;
  const { mobile: mobileCondition = true, desktop: desktopCondition = true } =
    props.conditions || defaultConditions;

  const ForcedLayout = props.forceViewport ? props[props.forceViewport] : null;
  const forcedLayoutConditions = {
    mobile: props.forceViewport !== 'desktop',
    desktop: props.forceViewport !== 'mobile'
  };

  const forcedLayoutCondition = props.forceViewport
    ? forcedLayoutConditions[props.forceViewport]
    : true;

  return (
    <>
      {ForcedLayout && forcedLayoutCondition && (
        <Suspense>
          <ForcedLayout {...props.innerProps} />
        </Suspense>
      )}
      <Suspense fallback={props.fallback || null}>
        {!ForcedLayout
          ? isMobile()
            ? mobileCondition && <MobileView {...props.innerProps} />
            : desktopCondition && <DesktopView {...props.innerProps} />
          : null}
      </Suspense>
    </>
  );
};
